import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ENV_CONFIG } from '../interface/firebase-env';
import { CONSOLE_SHARED_PROVIDER } from '../providers/console-shared.provider';
import { GET_SITE_PROVIDER } from '../providers/get-site.provider';

export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ENV_CONFIG, useValue: environment },
    GET_SITE_PROVIDER,
    CONSOLE_SHARED_PROVIDER,
  ]);
}
